import React, { useEffect, useRef, useState } from "react";
import "./Our_choices.css";
import Product_card from "../../common-components/product_card/Product_card";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOURProduct,
  getAllProducts,
  getAllProductsDetails,
  getOnlyProducts,
} from "../../../features/products/productsSlice";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import ScrollAnimation from "react-animate-on-scroll";
import { variant_type } from "../../../utils/common";
import Green_Outline_Btn from "../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";

function Our_choices() {
  const STEP = 4;
  const [showAll, setShowAll] = useState(false);

  const dispatch = useDispatch();

  const productdata = useSelector((state) => state.product.allProductsDetails);
  
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useSelector((state) => state.product.total_pages_detail) || 1;
  const current_page = useSelector((state) => state.product.currentPage_detail) || 1;

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  // const paginatedData = products?.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage,
  // );

  const sectionRef = useRef(null); // Ref for scrolling to top

  useEffect(() => {
    dispatch(
      getAllProductsDetails({
        page: currentPage,
        per_page: 8,
      }),
    );
  }, [dispatch, currentPage]);

  // const visibleProducts = showAll ? products : products.slice(0, STEP);

  const handleToggle = () => {
    if (showAll && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setShowAll(!showAll);
  };

   const isFetching = useRef(false);
    const loading = useSelector((state) => state.product.loading);
    useEffect(() => {
      const handleScroll = () => {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
  
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.offsetHeight;
  
        if (
          scrollTop + windowHeight >= fullHeight - 300 &&
          !loading &&
          currentPage < totalPages
        ) {
          setCurrentPage((prev) => prev + 1);
        }
      };
  
      window.addEventListener("scroll", handleScroll, { passive: true });
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, [loading, currentPage, totalPages]);
  
    useEffect(() => {
      if (!loading) {
        isFetching.current = false;
      }
    }, [loading]);
   
  return (
    <section className="Our_choices" ref={sectionRef}>
      <div className="heading_holder text-center">
        <h4 className="heading_text">Design You May Like </h4>
      </div>

      <div className="Our_choices_holder">
        <ScrollAnimation animateIn={"zoomIn"}>
          {productdata && productdata.length > 0 ? (
            <div className="row">
              {productdata?.map((product, index) => {
                let plating;
                let colour;
                let size;

                if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Single)
                ) {
                  plating = product?.Product_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Double)
                ) {
                  plating = product?.Product_Variants?.[0];
                  colour = plating?.Double_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Triple)
                ) {
                  plating = product?.Product_Variants?.[0];
                  colour = plating?.Double_Variants?.[0];
                  size = colour?.Triple_Variants?.[0];
                }

                const activeVariant = size || colour || plating;

                return (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-6 px-md-2 px-1"
                    key={product.id || index}
                  >
                    <Product_Info_Card
                      product={product}
                      id={product?.id}
                      imgSrc={product?.image}
                      vdoSrc={product?.image}
                      productName={product?.name}
                      prodDiscount={product?.prod_discount}
                      productDesignId={product?.design_id}
                      priceText={product?.Product_Variants?.[0].price || 0}
                      mrp={product?.Product_Variants?.[0].mrp}
                      savingPrice={
                        parseFloat(product?.Product_Variants?.[0].mrp || 0) -
                        parseFloat(product?.Product_Variants?.[0].price || 0)
                      }
                    />
                  </div>
                );
              })}
              {/* {visibleProducts?.map((product, index) => (
            <div
              className="col-lg-3 col-md-4 col-sm-6 col-6 px-md-2 px-1"
              key={index}
            >
              <Product_Info_Card
                product={product}
                id={product.id}
                imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                productName={product.name}
                priceText={product.Product_Variants[0]?.price}
                mrp={product.Product_Variants[0]?.mrp}
                kgText={product.Product_Variants[0]?.name}
                savingPrice={
                  parseFloat(product.Product_Variants[0]?.mrp || 0) -
                  parseFloat(product.Product_Variants[0]?.price || 0)
                }
              />
            </div>
          ))} */}
            </div>
          ) : (
            <div className="no_product_available_holder text-center w-100">
              <h3>No Product Available</h3>
            </div>
          )}
        </ScrollAnimation>

        {/* {products?.length > STEP && (
          <div className="see_more_btn_holder text-center mt-4">
            <Green_Outline_Btn
              btnText={showAll ? "See Less" : "See More"}
              onClick={handleToggle}
            />
          </div>
        )} */}
      </div>

      {/* Pagination UI */}
      {/* <div className="pagination pagination_holder mt-4 d-flex justify-content-center align-items-center gap-2">
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          &laquo;
        </button>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lsaquo;
        </button>

        
        {[currentPage].map((page) => (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={page === currentPage ? "active" : ""}
          >
            {page}
          </button>
        ))}

       
        {totalPages > 3 && (
          <>
            <span>...</span>

           
            <button
              onClick={() => handlePageChange(totalPages)}
              className={currentPage === totalPages ? "active" : ""}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &rsaquo;
        </button>
        <button
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          &raquo;
        </button>
      </div> */}
    </section>
  );
}

export default Our_choices;
